<template>
  <div data-app>
    <div class="uk-card uk-card-small uk-card-default uk-animation-fade">
      <div class="uk-card-header">
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-expand">
            <div class="uk-card-title uk-margin-remove-top">
              {{ local_page_keys.title_page_salary }}
              <span class="uk-label tm-label">Beta</span>
              <div style="width:300px"
                   class="uk-dropdown tm-dropdown tm-dropdown-bottom-center"
                   data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 400; delay-show: 0; offset: 10">
                {{local_page_keys.alert_test_version}}
              </div>
            </div>
          </div>
          <div class="uk-width-auto">
            <div class="uk-padding-xsmall" style="background-color: #4caf50;color: #fff;">
              {{ local_page_keys.to_payoff}} {{ totalWholeSumForUnpaidReports}}
            </div>
          </div>
        </div>
      </div>

      <div class="uk-card-body_">
        <!--шапка-->
        <div class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-text-center uk-text-small"
             data-uk-grid
             data-uk-height-match="target: > div > div"
             data-uk-sticky="start: 200; animation: uk-animation-slide-top"
             style="background-color: #fff;">
          <div class="tm-width-medium">
            <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center">
              <div class="uk-text-bold uk-text-muted" style="line-height: 1.2;">
                {{ local_page_keys.weeks }}
              </div>
            </div>
          </div>
          <div class="uk-width-expand">
            <div :class="'uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-child-width-1-'+(fields.length+1)+' tm-child-width-1-'+(fields.length+1)"
                 data-uk-grid
                 data-uk-height-match="target: .uk-padding-xsmall">
              <div v-for="(field,index) in fields" :key="index">
                <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center">
                  <div class="uk-text-bold uk-text-muted" style="line-height: 1.2;">
                    {{ local_page_keys[field.name] }}
                  </div>
                  <div v-if="getTooltip(field.name)"
                       class="uk-dropdown tm-dropdown tm-dropdown-bottom-center"
                       data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 400; delay-show: 0; offset: 10">
                    {{getTooltip(field.name)}}
                  </div>
                </div>
              </div>
              <div>
                <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center">
                  <div class="uk-text-bold uk-text-muted" style="line-height: 1.2;">
                    {{ local_page_keys.paid }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="uk-margin-remove">
        <!--строка-->
        <div class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-child-width-1-1 tm-grid-hover uk-text-small" data-uk-grid>
          <template v-for="(item, index) in items">
            <div v-if="item"
                 class="uk-animation-fade uk-animation-fast uk-position-relative 444"
                 :style="'z-index:' + item.date.week"
                 :key="item.date.week + '_' + index"
                 :id="item.date.week">
              <div class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-text-center"
                   data-uk-grid
                   data-uk-height-match="target: > div > div">
                <!--номер недели-->
                <div class="uk-text-left tm-width-medium">
                  <div v-if="item.date" class="uk-padding-xsmall uk-flex uk-flex-middle_ uk-flex-column">
                    <div class="uk-text-bold">
                      {{ item.date.week ? item.date.week : '-' }}
                    </div>
                    <div class="tm-text-small uk-text-muted" style="line-height: 1">
                      ({{ item.date.start ? item.date.start : '-' }} / {{ item.date.end ? item.date.end : '-' }})
                    </div>
                  </div>
                </div>
                <div class="uk-width-expand">
                 <div :class="'uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-child-width-1-'+(fields.length+1)+' tm-child-width-1-'+(fields.length+1)"
                      data-uk-grid
                      data-uk-height-match="target: > div > div">
                   <div v-for="(field, fieldKey) in fields" :key="fieldKey">
                     <div class="uk-padding-small uk-flex uk-flex-middle uk-flex-column uk-flex-center">
                       <div :class="field.class">
                         {{ item.report[field.name] }}
                       </div>
                       <div v-if="getTooltipData(item,field.name)"
                            :id="'tooltipData' + fieldKey"
                            style="width:400px"
                            class="uk-dropdown tm-dropdown tm-dropdown-bottom-center"
                            data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 400; delay-show: 0; offset: 10">
                         <div class="uk-text-left" v-html="getTooltipData(item,field.name)"></div>
                       </div>
                     </div>
                   </div>
                   <div>
                     <div class="uk-padding-small uk-flex uk-flex-middle uk-flex-column uk-flex-center">
                      {{ item.report['date'] }}
                     </div>
                   </div>
                 </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <hr class="uk-margin-remove">
        <!--кнопка-->
        <div class="uk-margin uk-text-center">
          <button
             @click="getMore"
             :disabled="loadingRaw"
             class="uk-button uk-button-success tm-light">
            <md-icon>add</md-icon>
            <span v-if="loadingRaw" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      local_page_keys: {},
      fields: [
        // 'weeks',
        {
          name: 'num_orders',
          class: ''
        },
        {
          name: 'sum_for_orders',
          class: 'uk-text-bold'
        },
        {
          name: 'count_waiting_minutes',
          class: ''
        },
        {
          name: 'waiting_minutes_sum',
          class: 'uk-text-bold'
        },
        {
          name: 'salary_bonus',
          class: ''
        },
        {
          name: 'salary_bonus_sum',
          class: 'uk-text-bold'
        },
        {
          name: 'bonus_for_schedule',
          class: 'uk-text-bold'
        },
        {
          name: 'additional_payment',
          class: 'uk-text-bold'
        },
        {
          name: 'whole_sum',
          class: 'uk-text-bold'
        },
        // 'paid'
      ],
      loadingRaw: false,
      moreItemsButton: true,
      page: 0,
      items: [],
      loading: false
    }
  },
  computed: {
    totalWholeSumForUnpaidReports() {
      return this.items.reduce((total, report) => {
        if (report.report.date === null) {
          return Math.ceil(total + report.report.whole_sum);
        } else {
          return Math.ceil(total);
        }
      }, 0);
    }
  },
  methods: {
    async getMore() {
      if (!this.moreItemsButton) {
        return;
      }
      this.loadingRaw = true;
      this.moreItemsButton = false;
      let error = "";
      let formData = new FormData();
      formData.append('page', this.page);
      await this.$store.dispatch('salary/reportRetoucherSalaryData', formData).catch((reason => {
        this.moreItemsButton = true;
        error = true;
      }));
      if (!error) {
        let row = await this.$store.getters['salary/reportRetoucherSalaryData'];
        //console.log(row)
        this.items.push(row);
        this.page++;
        this.moreItemsButton = true;
      }
      this.loadingRaw = false;
    },
    getTooltip(field) {
      let tooltipName = 'tooltip_' + field;
      return this.local_page_keys[tooltipName];
    },
    getTooltipData(item, field) {
      let tooltipName = 'tooltip_data_' + field;
      return item.tooltip_data[tooltipName];
    }
  },

  async mounted() {
    this.local_page_keys = await this.$filtergetLocalisationPage('salary');
    this.getMore();
  },

}
</script>

<style></style>